exports.components = {
  "component---src-pages-product-dynamic-pricing-index-js": () => import("./../../../src/pages/product/dynamic-pricing/index.js" /* webpackChunkName: "component---src-pages-product-dynamic-pricing-index-js" */),
  "component---src-pages-product-market-finder-index-js": () => import("./../../../src/pages/product/market-finder/index.js" /* webpackChunkName: "component---src-pages-product-market-finder-index-js" */),
  "component---src-templates-product-js": () => import("./../../../src/templates/product.js" /* webpackChunkName: "component---src-templates-product-js" */)
}

